export default "__VITE_ASSET__BcaA0FJP__"